<script>
export default {
    name: 'IlluParent',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-parent"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <circle
                :stroke="secondaryColor"
                class="secondary-color"
                cx="27.084"
                cy="16"
                r="7.5"
            />
            <path
                d="M43 36.5c-2.92 0-5.616.99-7.79 2.663a13.524 13.524 0 00-4.689 6.838 13.524 13.524 0 004.689 6.836 12.727 12.727 0 0015.58 0A13.526 13.526 0 0055.479 46a13.524 13.524 0 00-4.689-6.837A12.727 12.727 0 0043 36.5z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <circle
                :stroke="secondaryColor"
                class="secondary-color"
                cx="43"
                cy="28"
                r="5.5"
            />
            <path
                d="M36 26v-.134a1 1 0 010-1.732V22l7-3 7 3-7 3-6.5-2.786V24a1 1 0 01.993.883L37.5 25a1 1 0 01-1 1H36z"
                :fill="primaryColor"
                class="primary-color"
            />
            <path
                d="M33 28c-1.667-.667-3.667-1-6-1-3.5 0-14.5 1.5-19 14 4 10.667 12 15.167 24 13.5"
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
            />
        </g>
    </svg>
</template>
